<template>
    <Modal v-model="show" title="客户经理项目人角色部门信息" :width="60">
        <Spin v-if="$globalSpin" size="large" fix></Spin>
        <Form
            ref="modelForm"
            :model="modelForm"
            :rules="ruleValidate"
            label-position="top"
            class="small-form"
        >
            <Row :gutter="16">
                <Col span="24">
                    <FormItem label="选择角色" prop="roleId">
                        <Select v-model="modelForm.roleId" filterable clearable>
                            <Option
                                v-for="item in roleList"
                                :key="item.roleUuid"
                                :value="item.roleUuid"
                                :label="item.name"
                            ></Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="24">
                    <FormItem label="选择公司" prop="projectCompany">
                        <Select
                            v-model="modelForm.projectCompany"
                            @on-change="onCompanyChange"
                            filterable
                            clearable
                        >
                            <Option
                                v-for="item in companyList"
                                :key="item.projectCompany"
                                :value="item.projectCompany"
                                :label="item.projectCompany"
                            ></Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="24">
                    <FormItem label="选择部门(支持多选)" prop="projectNames">
                        <Select
                            v-model="modelForm.projectNames"
                            filterable
                            multiple
                            clearable
                        >
                            <Option
                                v-for="item in deptList"
                                :key="item.projectName"
                                :value="item.projectName"
                                :label="item.projectName"
                            ></Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="状态" prop="recordStatus">
                        <RadioGroup
                            v-model="modelForm.recordStatus"
                            type="button"
                        >
                            <Radio
                                v-for="item in statusSource"
                                :key="item.val"
                                :label="item.val"
                                >{{ item.label }}
                            </Radio>
                        </RadioGroup>
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <div slot="footer">
            <Button type="primary" @click="onSave">确认</Button>
            <Button type="error" @click="onCancel">取消</Button>
        </div>
    </Modal>
</template>

<script>
import { STATUS_YES, STATUS_NO, statusNewFormat } from "@/libs/baseModelFormat";
import {
    FORM_EDIT_MODE_CREATE,
    FORM_EDIT_MODE_MODIFY
} from "@/view/mixins/form-edit-mode";

import {
    getRoleList,
    getCustomerMgrCompanyList,
    getCustomerMgrDeptList,
    batchAddRoleProject
} from "@/api/modules/account-management/inspector-user-management";

export default {
    name: "RoleDeptCusMgrLeaderEdit",
    data() {
        return {
            show: false,
            uuid: "",
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            formEditMode: FORM_EDIT_MODE_CREATE,
            pageLoading: false,
            modelForm: {
                roleId: "",
                projectCompany: "",
                projectNames: [],
                recordStatus: STATUS_YES
            },
            ruleValidate: {
                roleId: [
                    {
                        trigger: "blur",
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                callback();
                            }
                            else {
                                callback(new Error(" "));
                            }
                        }
                    }
                ],
                projectCompany: [
                    {
                        trigger: "blur",
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                callback();
                            }
                            else {
                                callback(new Error(" "));
                            }
                        }
                    }
                ],
                projectNames: [
                    {
                        trigger: "blur",
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                callback();
                            }
                            else {
                                callback(new Error(" "));
                            }
                        }
                    }
                ]
            },
            statusSource: [],
            roleList: [],
            companyList: [],
            deptList: []
        };
    },
    mounted() {},
    methods: {
        showModal(uuid) {
            if (uuid == "") {
                this.uuid = "";
                this.formEditMode = FORM_EDIT_MODE_CREATE;
            }
            else {
                this.formEditMode = FORM_EDIT_MODE_MODIFY;
                this.uuid = uuid;
            }
            this.init();
            this.show = true;
        },
        init() {
            this.statusSource = [];
            this.statusSource.push({
                val: STATUS_YES,
                label: statusNewFormat(STATUS_YES)
            });
            this.statusSource.push({
                val: STATUS_NO,
                label: statusNewFormat(STATUS_NO)
            });
            this.getRoleList();
            this.getCompanyList();
            this.$refs.modelForm.resetFields();
        },
        getRoleList() {
            getRoleList({
                type: "客户经理项目人"
            }).then((res) => {
                if (res.code === 0) {
                    this.roleList = res.data.records;
                }
            });
        },
        getCompanyList() {
            getCustomerMgrCompanyList().then((res) => {
                if (res.code === 0) {
                    this.companyList = res.data.records;
                }
            });
        },
        onCompanyChange() {
            if (this.modelForm.projectCompany) {
                getCustomerMgrDeptList({
                    projectCompany: this.modelForm.projectCompany
                }).then((res) => {
                    if (res.code === 0) {
                        this.deptList = res.data.records;
                    }
                });
            }
            else {
                this.deptList = [];
            }
        },
        onSave() {
            this.$refs.modelForm.validate((valid) => {
                if (!valid) {
                    this.$Message.error("表单验证失败!");
                    return;
                }

                const data = Object.assign(
                    {
                        formEditMode: this.formEditMode
                    },
                    this.modelForm
                );

                this.$showGlobalSpin();
                batchAddRoleProject(data).then((res) => {
                    this.$hideGlobalSpin();
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: "保存成功",
                            onOk: () => {
                                this.show = false;
                                this.$refs.modelForm.resetFields();
                                this.$parent.getTableRecords();
                            }
                        });
                    }
                });
            });
        },
        onCancel() {
            this.show = false;
            this.$refs.modelForm.resetFields();
        }
    }
};
</script>

<style scoped></style>
